export const COPILOT_POLL_INTERVAL_MS = 2_000;

export function copilotConversationPollInterval(
  localRunConversationId: string | null,
  currentConversationId: string | null | undefined,
  serverTurnStatus: string | null | undefined,
  actions: ReadonlyArray<{ status: string; reconciling: boolean }> = [],
): number | false {
  const localRunActive =
    localRunConversationId !== null && localRunConversationId === currentConversationId;
  const actionNeedsRefresh = actions.some(
    (action) =>
      action.status === "pending" ||
      action.status === "running" ||
      (action.status === "unknown" && action.reconciling),
  );
  return localRunActive || serverTurnStatus === "running" || actionNeedsRefresh
    ? COPILOT_POLL_INTERVAL_MS
    : false;
}
